import {
  TableContainer,
  Paper,
  Table,
  TableBody,
  TableHead,
  Typography,
} from "@mui/material";
import {
  StyledTableCellValueTemplate,
  StyledTableCellLabelTemplate,
  LabelTemplate,
  StyledTableRowTemplate,
  StyledTableContainer,
} from "../../styles/table";
import { Employee } from "../../../types/processTypes";

import { tt } from "../../../../../data/langUtility";

interface Props {
  currentEmployee: Employee;
  template: LabelTemplate;
}
export const BasicRemarks = ({ currentEmployee, template }: Props) => {
  return (
    <>
      <StyledTableContainer
        template={template}
        sx={{
          marginTop: template.spacing,
        }}
      >
        <Table size="small" aria-label="simple table">
          <TableBody>
            <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  width: "20%",
                }}
              >
                {tt("remarks", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate
                sx={{ width: "60%" }}
                template={template}
              >
                {currentEmployee.additionalData?.notes as string}
              </StyledTableCellValueTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  width: "20%",
                  textAlign: "right",
                }}
              >
                {tt("remarks", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};

export const BasicRemarksUltra = ({ currentEmployee, template }: Props) => {
  return (
    <>
      <StyledTableContainer
        template={template}
        sx={{
          marginTop: template.spacing,
        }}
      >
        <Table size="small" aria-label="simple table">
          <TableHead>
            <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  width: "20%",
                }}
              >
                {tt("remarks", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate
                sx={{ width: "60%" }}
                template={template}
              ></StyledTableCellValueTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  width: "20%",
                  textAlign: "right",
                }}
              >
                {tt("remarks", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
          </TableHead>
          <TableBody>
            <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellValueTemplate
                colSpan={3}
                sx={{ width: "100%", textAlign: "center" }}
                template={template}
              >
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  {
                    "TRUSTWORTHY AND HARDWORKING PERSON SHE CAN DO HOUSEHOLD CHORES AND SHE IS WILLING TO LEARN MORE."
                  }
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  {
                    "شخصية جديرة بالثقة ومجتهدة، تستطيع القيام بالأعمال المنزلية وهي على استعداد لتعلم المزيد."
                  }
                </Typography>
              </StyledTableCellValueTemplate>
            </StyledTableRowTemplate>
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};

export const BasicRemarksVer = ({ currentEmployee, template }: Props) => {
  return (
    <>
      <StyledTableContainer
        template={template}
        sx={{
          marginTop: template.spacing,
        }}
      >
        <Table size="small" aria-label="simple table">
          <TableHead>
            <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "center",
                }}
              >
                {tt("remarks", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
          </TableHead>
          <TableBody>
            <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellValueTemplate
                sx={{
                  textAlign: "center",
                }}
                template={template}
              >
                {currentEmployee.additionalData?.notes as string}
              </StyledTableCellValueTemplate>
            </StyledTableRowTemplate>
            {/* <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "center",
                }}
              >
                {tt("remarks", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate> */}
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};

export const BasicRemarksBullets = ({ currentEmployee, template }: Props) => {
  return (
    <>
      <StyledTableContainer
        template={template}
        sx={{
          marginTop: template.spacing,
        }}
      >
        <Table size="small" aria-label="simple table">
          <TableHead>
            <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                }}
              >
                {tt("remarks", "en")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
          </TableHead>
          <TableBody>
            <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellValueTemplate
                sx={{
                  textAlign: "left",
                }}
                template={template}
              >
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  {"* SHE HAVE EXPERIENCE"}
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  {"* WILLING TO TAKE CARE OF NEWBORN BABY AND ELDERLY PEOPLE"}
                </Typography>
                {/* <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  {"* WILLING TO LEARN HOW TO COOK BASIC ARABIC FOOD"}
                </Typography> */}
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  {"* CAN DO ALL KINDS OF HOUSEHOLD WORK"}
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  {"* CAN’T SPEAK, READ AND WRITE BASIC ENGLISH LANGUAGE"}
                </Typography>
              </StyledTableCellValueTemplate>
            </StyledTableRowTemplate>
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};

export const BasicRemarksConfidential = ({
  currentEmployee,
  template,
}: Props) => {
  return (
    <>
      <StyledTableContainer
        template={template}
        sx={{
          marginTop: template.spacing,
        }}
      >
        <Table size="small" aria-label="simple table">
          <TableHead>
            <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellValueTemplate
                sx={{
                  textAlign: "center",
                }}
                template={template}
              >
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  {"I HEREBY DECLARE THAT THE ABOVE PARTICULARS FURNISHED"}
                </Typography>
              </StyledTableCellValueTemplate>
            </StyledTableRowTemplate>
          </TableHead>
        </Table>
      </StyledTableContainer>
    </>
  );
};
